import buildApplicationInformationSection from './ApplicationInformation';
import buildEmploymentStatusSection from './EmploymentAndIncome/EmploymentStatus';
import buildResidentialInformationSection from './ResidentialInformation';
import buildAdditionalInformationSection from './AdditionalInformation';
import StudentAndAssistanceInformationSection from './StudentAndAssistanceInformation';
import buildHouseholdMembersSection from './HouseholdMembers';
import buildSigningMethodSection from './SigningMethod';

const buildSchema = ({
  propertyState,
  applicantData,
  isAffordable = false,
  propertyStateCode,
  affordablePrograms,
  canSignElectronically = false,
  isPendingResidentApplicant = false,
  formatMessage,
}) => {
  return [
    {
      name: 'leaseApplicationForm',
      container: 'default',
      fields: [
        {
          name: 'mainFields',
          container: 'default',
          border: true,
          fields: [
            buildApplicationInformationSection({
              isAffordable,
              propertyStateCode,
              affordablePrograms,
              isFinanciallyResponsible: applicantData.isFinanciallyResponsible,
              applicantTypeName: applicantData.applicantTypeName,
              affordableRelationship: applicantData.affordableRelationship,
            }),
            ...(isAffordable ? [StudentAndAssistanceInformationSection] : []),
            buildEmploymentStatusSection({
              isFinanciallyResponsible: applicantData.isFinanciallyResponsible,
            }),
            buildResidentialInformationSection({
              isFinanciallyResponsible: applicantData.isFinanciallyResponsible,
            }),
            ...(applicantData.isFinanciallyResponsible
              ? [
                  buildHouseholdMembersSection({
                    isProspect: applicantData.isProspect,
                    isAffordable,
                    affordablePrograms,
                    propertyStateCode,
                  }),
                ]
              : []),
            buildAdditionalInformationSection({
              propertyState,
              applicantData,
            }),
          ],
        },
        {
          variant: 'custom',
          component: <div style={{ height: '15px' }} />,
        },
        buildSigningMethodSection({
          canSignElectronically,
          isPendingResidentApplicant,
          formatMessage,
        }),
      ],
    },
  ];
};

export default buildSchema;
